// prop-types is a library for typechecking of props

// @mui material components

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Logo from "assets/images/authenticationImages/Logo.png";
import loginpageimage from "assets/images/authenticationImages/loginpageimage.png";
import resetpasspageimage from "assets/images/authenticationImages/resetpasspageimage.png";

function CoverLayout({ showPassword = true, children, isLogin }) {
  return (
    <PageLayout vairent="gradient" background="linear-gradient(180deg, #3DC2EB 10%, #023e51ff 90%)">
      <SoftBox
        display="flex"
        sx={{
          width: "100%",
          height: "100%",
          p: { xs: 1, sm: 2, md: 4 },
          flexDirection: "column",
          gap: 3,
        }}
      >
        <SoftBox
          sx={{
            flexDirection: { xs: "column", lg: "row" },
            alignItems: { xs: "center", lg: "start" },
          }}
          display="flex"
        >
          <SoftBox>
            <SoftBox
              height="130px"
              width="200px"
              sx={{
                backgroundImage: `url(${Logo})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
          </SoftBox>

          <SoftBox
            width="100%"
            display="flex"
            sx={{
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              mt: { xs: 3, sm: 3, md: 7 },
              mr: { xs: 0, sm: 0, lg: 15 },
            }}
          >
            <SoftTypography sx={{ fontSize: { xs: 22, sm: 25, md: 36 }, color: "white.main" }}>
              {isLogin ? "Your Control Center" : "Reset Your Access"}
            </SoftTypography>

            <SoftBox sx={{ textAlign: "center" }}>
              <SoftTypography
                sx={{
                  fontSize: 16,
                  color: "white.main",
                  display: { xs: "inline", lg: "block" },
                }}
              >
                {isLogin
                  ? "Access powerful tools to add universities, track users,"
                  : "We’ll help you set a new password and regain access "}
              </SoftTypography>

              <SoftTypography
                sx={{
                  fontSize: 16,
                  color: "white.main",
                  display: { xs: "inline", lg: "block" },
                }}
              >
                {isLogin ? "and ensure smooth operations." : "instantly."}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <SoftBox display="flex"
 sx={{ alignItems: "start", justifyContent: "center", height:"475px" }}>
          <SoftBox
            sx={{
              width: "100%",
              display: { xs: "none", lg: "flex" },
              alignItems: "center",
              justifyContent: "start",
              pt: 4,
            }}
          >
            <SoftBox
              height="438px"
              width="570px"
              sx={{
                backgroundImage: `url(${isLogin ? loginpageimage : resetpasspageimage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
          </SoftBox>

          <SoftBox
            display="flex"
            sx={{
              width: { xs: "100%", sm: "100%", md: "80%" },
              height: "100%",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            {children}
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
}

export default CoverLayout;
